import React, { useState } from "react";
import { ChevronDownIcon, ChevronUpIcon, TrashIcon } from "@heroicons/react/20/solid";
import Allergen from "./Allergen";

const MenuItem = ({ menuItem, deleteMenuItem, changeImage }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div
      style={{
        background: "var(--white)",
        border: "1px solid var(--border)",
        borderRadius: "12px",
        padding: "16px",
        marginBottom: "10px",
        boxShadow: "var(--shadow)",
      }}
    >
      <div style={{ display: "flex", alignItems: "flex-start", gap: "14px" }}>

        {/* Image */}
        <div style={{ position: "relative", flexShrink: 0 }}>
          <img
            src={decodeURIComponent(menuItem.itemImage)}
            alt={menuItem.itemName}
            style={{ width: "72px", height: "72px", objectFit: "cover", borderRadius: "8px", display: "block" }}
          />
          <div
            onClick={() => changeImage("menuItem", menuItem._id, menuItem.itemName)}
            style={{
              position: "absolute", inset: 0,
              display: "flex", alignItems: "center", justifyContent: "center",
              background: "rgba(0,0,0,0.5)", color: "white",
              fontSize: "11px", fontWeight: 600, borderRadius: "8px",
              opacity: 0, cursor: "pointer", transition: "opacity 0.2s",
            }}
            onMouseEnter={(e) => e.currentTarget.style.opacity = 1}
            onMouseLeave={(e) => e.currentTarget.style.opacity = 0}
          >
            Change
          </div>
        </div>

        {/* Details */}
        <div style={{ flex: 1, minWidth: 0 }}>
          <p style={{ fontSize: "15px", fontWeight: 600, color: "var(--ink)", margin: "0 0 2px" }}>
            {menuItem.itemName}
          </p>
          <p style={{ fontSize: "13px", color: "var(--ink-soft)", margin: "0 0 4px" }}>
            {menuItem.itemDescription}
          </p>
          <p style={{ fontSize: "14px", fontWeight: 600, color: "var(--ink)", margin: 0 }}>
            £{menuItem.itemPrice.toFixed(2)}
          </p>
        </div>

        {/* Actions */}
        <div style={{ display: "flex", alignItems: "center", gap: "4px", flexShrink: 0 }}>
          <button
            onClick={() => deleteMenuItem(menuItem._id)}
            style={{
              display: "flex", alignItems: "center", justifyContent: "center",
              width: "32px", height: "32px", borderRadius: "6px",
              background: "none", border: "1px solid #FBCCC0",
              color: "var(--accent)", cursor: "pointer",
            }}
            title="Delete item"
          >
            <TrashIcon style={{ width: "16px", height: "16px" }} />
          </button>
          <button
            onClick={() => setExpanded(!expanded)}
            style={{
              display: "flex", alignItems: "center", justifyContent: "center",
              width: "32px", height: "32px", borderRadius: "6px",
              background: "none", border: "1px solid var(--border)",
              color: "var(--ink-muted)", cursor: "pointer",
            }}
            title={expanded ? "Collapse" : "Show allergens & ingredients"}
          >
            {expanded
              ? <ChevronUpIcon style={{ width: "16px", height: "16px" }} />
              : <ChevronDownIcon style={{ width: "16px", height: "16px" }} />}
          </button>
        </div>
      </div>

      {/* Expanded detail */}
      {expanded && (
        <div
          style={{
            marginTop: "14px",
            paddingTop: "14px",
            borderTop: "1px solid var(--border)",
          }}
        >
          <p style={{ fontSize: "12px", fontWeight: 700, color: "var(--ink-muted)", textTransform: "uppercase", letterSpacing: "0.07em", marginBottom: "4px" }}>
            Ingredients
          </p>
          <p style={{ fontSize: "13px", color: "var(--ink-soft)", marginBottom: "14px" }}>
            {menuItem.itemIngredients}
          </p>

          {menuItem.itemAllergens?.length > 0 ? (
            <>
              <p style={{ fontSize: "12px", fontWeight: 700, color: "var(--ink-muted)", textTransform: "uppercase", letterSpacing: "0.07em", marginBottom: "8px" }}>
                Allergens
              </p>
              <div style={{ overflowX: "auto" }}>
                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
                  <thead>
                    <tr style={{ borderBottom: "2px solid var(--border)" }}>
                      {["Allergen", "May Contain", "Included", "Alternative Available", "Alternative Details"].map((h) => (
                        <th
                          key={h}
                          style={{
                            padding: "6px 10px",
                            textAlign: h === "Allergen" ? "left" : "center",
                            fontSize: "11px",
                            fontWeight: 700,
                            color: "var(--ink-muted)",
                            textTransform: "uppercase",
                            letterSpacing: "0.06em",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {h}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {menuItem.itemAllergens.map((allergen) => (
                      <Allergen key={allergen._id} allergen={allergen} />
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          ) : (
            <p style={{ fontSize: "13px", color: "var(--ink-muted)", fontStyle: "italic" }}>
              No allergens recorded.
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default MenuItem;
